import { PALETTE_1, PALETTE_2, PALETTE_3, PALETTE_4, PALETTE_5 } from './paletteConfig';

/**
 * @type {import('@mui/material/styles').PaletteOptions}
 */
const PALETTES = {
    palette1: PALETTE_1,
    palette2: PALETTE_2,
    palette3: PALETTE_3,
    palette4: PALETTE_4,
    palette5: PALETTE_5,
};

/**
 * @type {import ('@mui/material/styles').TypographyVariants}
 */

const TYPOGRAPHY = {
    h1Large: {
        fontFamily: 'eirsans-bold',
        fontWeight: '400',
        fontSize: '3.375rem',
        lineHeight: '3.875rem',
        '@media (max-width: 600px)': {
            fontSize: '2.331rem',
            lineHeight: '2.831rem',
        },
    },
    h1: {
        fontFamily: 'eirsans-bold',
        fontWeight: '400',
        fontSize: '2rem',
        lineHeight: '3rem',
        '@media (max-width: 600px)': {
            fontSize: '1.75rem',
            lineHeight: '2.225rem',
        },
    },
    h2Large: {
        fontFamily: 'eirsans-bold',
        fontWeight: '400',
        fontSize: '3.375rem',
        lineHeight: '3.875rem',
        '@media (max-width: 600px)': {
            fontSize: '2.331rem',
            lineHeight: '2.831rem',
        },
    },
    h2: {
        fontFamily: 'eirsans-bold',
        fontWeight: '400',
        fontSize: '1.5rem',
        lineHeight: '2.5rem',
        '@media (max-width: 600px)': {
            fontSize: '1.5rem',
            lineHeight: '2.038rem',
        },
    },
    h3: {
        fontFamily: 'eirsans-bold',
        fontWeight: '400',
        fontSize: '1.25rem',
        lineHeight: '2.25',
        '@media (max-width: 600px)': {
            fontSize: '1.25rem',
            lineHeight: '1.938rem',
        },
    },
    h4: {
        fontFamily: 'eirsans-bold',
        fontWeight: '400',
        fontSize: '1.125rem',
        lineHeight: '2rem',
        '@media (max-width: 600px)': {
            fontSize: '1.125rem',
            lineHeight: '1.844rem',
        },
    },
    h5: {
        fontFamily: 'eirsans-bold',
        fontWeight: '400',
        fontSize: '1rem',
        lineHeight: '1.75rem',
        '@media (max-width: 600px)': {
            fontSize: '1rem',
            lineHeight: '1.75rem',
        },
    },
    h6: {
        fontFamily: 'eirsans-bold',
        fontWeight: '400',
        fontSize: '0.875rem',
        lineHeight: '1.5rem',
        '@media (max-width: 600px)': {
            fontSize: '0.875rem',
            lineHeight: '1.5rem',
        },
    },

    subtitle1: {
        fontFamily: 'eirsans-bold',
        fontWeight: '400',
        fontSize: '1rem',
        lineHeight: '1.5rem',
        '@media (max-width: 600px)': {
            fontSize: '1rem',
            lineHeight: '1.5rem',
        },
    },
    subtitle2: {
        fontFamily: 'eirsans-bold',
        fontWeight: '400',
        fontSize: '0.875rem',
        lineHeight: '1.375rem',
        '@media (max-width: 600px)': {
            fontSize: '0.875rem',
            lineHeight: '1.375rem',
        },
    },
    subtitle3: {
        fontFamily: 'eirsans-bold',
        fontWeight: '400',
        fontSize: '1.125rem',
        lineHeight: '1.625rem',
        '@media (max-width: 600px)': {
            fontSize: '1.125rem',
            lineHeight: '1.625rem',
        },
    },

    body1: {
        fontFamily: 'eirsans-light',
        fontWeight: '400',
        fontSize: '1rem',
        lineHeight: '1.5rem',

        '@media (max-width: 600px)': {
            fontSize: '1rem',
            lineHeight: '1.5rem',
        },
    },
    body2: {
        fontFamily: 'eirsans-light',
        fontWeight: '400',
        fontSize: '0.875rem',
        lineHeight: '1.375rem',
        '@media (max-width: 600px)': {
            fontSize: '0.875rem',
            lineHeight: '1.375rem',
        },
    },
    body3: {
        fontFamily: 'eirsans-light',
        fontWeight: '400',
        fontSize: '1.125rem',
        lineHeight: '1.625rem',
        '@media (max-width: 600px)': {
            fontSize: '1.125rem',
            lineHeight: '1.625rem',
        },
    },
    body3Medium: {
        fontFamily: 'eirsans-light',
        fontWeight: '400',
        fontSize: '1.125rem',
        lineHeight: '1.625rem',
        color: '#F5EBDA',
        backgroundColor: 'rgba(0, 0, 0, 0.60)',
        '@media (max-width: 600px)': {
            fontSize: '1.125rem',
            lineHeight: '1.625rem',
        },
    },

    caption: {
        fontFamily: 'eirsans-light',
        fontWeight: '400',
        fontSize: '0.813rem',
        lineHeight: '1.25rem',
        '@media (max-width: 600px)': {
            fontSize: '1rem',
            lineHeight: '1.5rem',
        },
    },
    overline: {
        fontFamily: 'eirsans-light',
        fontWeight: '400',
        fontSize: '0.75rem',
        lineHeight: '1.375rem',
        '@media (max-width: 600px)': {
            fontSize: '0.75rem',
            lineHeight: '1.375rem',
        },
    },

    avatarLetter: {
        fontFamily: 'eirsans-light',
        fontWeight: '400',
        fontSize: '1.25rem',
        lineHeight: '1.75rem',
        '@media (max-width: 600px)': {
            fontSize: '1.25rem',
            lineHeight: '1.75rem',
        },
    },
    inputLabel: {
        fontFamily: 'eirsans-light',
        fontWeight: '400',
        fontSize: '0.75rem',
        lineHeight: '0.75rem',
        '@media (max-width: 600px)': {
            fontSize: '0.75rem',
            lineHeight: '0.75rem',
        },
    },
    helperText: {
        fontFamily: 'eirsans-light',
        fontWeight: '400',
        fontSize: '0.875rem',
        lineHeight: '1.375rem',
        '@media (max-width: 600px)': {
            fontSize: '0.875rem',
            lineHeight: '1.375rem',
        },
    },
    inputText: {
        fontFamily: 'eirsans-light',
        fontWeight: '400',
        fontSize: '1rem',
        lineHeight: '1.5rem',
        '@media (max-width: 600px)': {
            fontSize: '1rem',
            lineHeight: '1.5rem',
        },
    },

    tooltip: {
        fontFamily: 'eirsans-regular',
        fontWeight: '400',
        fontSize: '0.625rem',
        lineHeight: '1.125rem',
        '@media (max-width: 600px)': {
            fontSize: '0.625rem',
            lineHeight: '1.125rem',
        },
    },

    a: {
        fontFamily: 'eirsans-regular',
        textDecoration: 'underline',
        '&:hover': {
            textDecoration: 'underline',
            cursor: 'pointer',
        },
    },
};

/**
 * @type {import('@mui/material/styles').Breakpoints}
 */
const BREAKPOINTS = {
    values: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920,
    },
};

export { PALETTES, TYPOGRAPHY, BREAKPOINTS };
